import { useTranslation } from 'react-i18next';
import { scenes } from '@/config/siteImages';

const steps = [
  {
    num: '01',
    labelKey: 'step_1_label',
    titleKey: 'step_1_title',
    descKey: 'step_1_desc',
    complianceKey: '',
    icon: 'ri-file-list-3-line',
    img: scenes.howStep1,
  },
  {
    num: '02',
    labelKey: 'step_2_label',
    titleKey: 'step_2_title',
    descKey: 'step_2_desc',
    complianceKey: 'step_2_compliance',
    icon: 'ri-search-eye-line',
    img: scenes.howStep2,
  },
  {
    num: '03',
    labelKey: 'step_3_label',
    titleKey: 'step_3_title',
    descKey: 'step_3_desc',
    complianceKey: 'step_3_compliance',
    icon: 'ri-bank-card-line',
    img: scenes.howStep3,
  },
];

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-[#F8F3FB] px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold text-[#4F2D63] uppercase tracking-widest mb-3">
            Simple Process
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('how_title')}
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            {t('how_subtitle')}
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {steps.map(({ num, labelKey, titleKey, descKey, complianceKey, icon, img }, idx) => (
            <div key={num} className="relative">
              {/* Connector line (desktop) */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-[3.5rem] left-[calc(50%+4rem)] right-[-50%] h-px border-t-2 border-dashed border-[#E9D9F2] z-0" />
              )}

              <div className="relative z-10 bg-white rounded-2xl overflow-hidden border border-[#E9D9F2] h-full flex flex-col">
                {/* Step image */}
                <div className="w-full h-44 overflow-hidden flex-shrink-0">
                  <img
                    src={img}
                    alt={t(titleKey)}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                <div className="p-7 flex flex-col flex-1">
                  {/* Step number badge */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#4F2D63] flex-shrink-0">
                      <span className="text-white text-sm font-bold">{num}</span>
                    </div>
                    <p className="text-xs font-semibold text-[#4F2D63] uppercase tracking-wider">
                      {t(labelKey)}
                    </p>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {t(titleKey)}
                  </h3>
                  <p className="text-sm text-gray-500 leading-relaxed flex-1">
                    {t(descKey)}
                  </p>

                  {complianceKey && (
                    <p className="text-xs text-gray-400 italic mt-4 pt-4 border-t border-gray-100">
                      * {t(complianceKey)}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <a
            href="/how-it-works"
            className="inline-flex items-center gap-2 text-[#4F2D63] font-semibold text-sm hover:text-[#3E234F] transition-colors cursor-pointer"
          >
            Learn more about our process
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
